import { useParams } from "react-router-dom";
import AppBreadcrumbs from "../../components/common/breadcrumbs/AppBreadcrumbs.jsx";
import Page from "../../components/layout/Page.jsx";
import ReceiptElement from "../../components/layout/ReceiptElement.jsx";
import useReceiptPartidas from "../../hooks/usePartidas.jsx";
import useReceipt from "../../hooks/useReceipt.jsx";

const Receipt = () => {
  const { receiptId } = useParams();
  const { data: dataReceipt, loading: loadingReceipt, error: errorReceipt } = useReceipt(receiptId);
  const { data: dataPartidas, loading: loadingPartidas, error: errorPartidas } = useReceiptPartidas(receiptId);

  if (loadingReceipt) {
    return (
      <Page>
        <div>Cargando elemento</div>
      </Page>
    );
  }
  if (errorReceipt) {
    return (
      <Page>
        <div>Error: {errorReceipt.message}</div>
      </Page>
    );
  }
  if (!dataReceipt) {
    return (
      <Page>
        <div>No se han encontrado ningun elemento</div>
      </Page>
    );
  }

  const bcSteps = [
    { to: "/receipts", label: "Recepciones" },
  ];

  return (
    <Page>
      <AppBreadcrumbs steps={bcSteps} currentPage={dataReceipt.administrative_reference_code} />
      <ReceiptElement
        data={dataReceipt}
        dataPartidas={dataPartidas}
        loadingPartidas={loadingPartidas}
        errorPartidas={errorPartidas}
      />
    </Page>
  );
};

export default Receipt;
